export default __webpack_public_path__ + "static/part1_2-de6dffabc044c7621f224026de3b3166.png";